import {
  getTeacher,
  putTeacher,
  sendInternForm,
  getInternForm,
  getInternSearchOptions,
  getInternRecordList,
  getEnterprisesList,
  getStudentInternRecordList,
  getFileNameList,
  deleteInternFile,
  uploadInternFormFile,
  downloadInternFormFile,
  getTeacherReminder,
} from '~api/teachers'

export const state = () => ({
  currentTeacher: {},
  currentInternForm: {},
  currentStudentsList: [],
  currentEnterprisesList: [],
  currentStudentInternRecordList: [],
  currentInternRecordList: [],
  currentInternSearchOptions: {},
  currentTeacherReminder: [],
  currentFileNameList: [],
})

export const getters = {
  currentTeacherGetter: state => state.currentTeacher,
  currentInternFormGetter: state => state.currentInternForm,
  currentStudentsListGetter: state => state.currentStudentsList,
  currentEnterprisesListGetter: state => state.currentEnterprisesList,
  currentStudentInternRecordListGetter: state => state.currentStudentInternRecordList,
  currentInternRecordListGetter: state => state.currentInternRecordList,
  currentInternSearchOptionsGetter: state => state.currentInternSearchOptions,
  currentTeacherReminderGetter: state => state.currentTeacherReminder,
  currentFileNameListGetter: state => state.currentFileNameList,
}

export const actions = {
  async getTeacherByToken ({ commit, dispatch }) {
    try {
      const data = await getTeacher()
      commit('setCurrentTeacher', data)
      return data
    } catch (err) {
      dispatch('auth/userLogout', 'teacher', { root: true })
    }
  },
  async updateTeacherProfile ({ commit }, profile) {
    try {
      const data = await putTeacher(profile)
      commit('setCurrentTeacher', data)
      return data
    } catch (err) {
      return false
    }
  },
  logout ({ commit }) {
    commit('resetCurrentTeacher')
  },
  async sendInternForm ({ commit }, params) {
    const response = await sendInternForm(params);
    return response
  },
  async getInternForm ({ commit }, params) {
    const response = await getInternForm(params);
    const {
      formData
    } = response
    commit('setInternForm', formData)
    return response
  },
  async getInternSearchOptions ({ commit }) {
    const response = await getInternSearchOptions();
    const {
      internSearchOptions
    } = response
    commit('setInternSearchOptions', internSearchOptions)
    return response
  },
  async getInternRecordList ({ commit }, params) {
    const response = await getInternRecordList(params);
    const {
      internRecordList
    } = response
    commit('setInternRecordList', internRecordList)
    return response
  },
  async getEnterprisesList ({ commit }, keyword) {
    const response = await getEnterprisesList(keyword);
    const {
      enterprisesList
    } = response
    commit('setEnterprisesList', enterprisesList)
    return response
  },
  async getStudentInternRecordList ({ commit }, student_id) {
    const response = await getStudentInternRecordList(student_id);
    const {
      studentInternRecordList
    } = response
    commit('setStudentInternRecordList', studentInternRecordList)
    return response
  },
  async getFileNameList ({ commit }, params) {
    commit('setFileNameList', [])
    const response = await getFileNameList(params);
    const {
      fileNameList,
    } = response
    commit('setFileNameList', fileNameList)
    return response
  },
  async deleteInternFile ({ commit }, params) {
    const response = await deleteInternFile(params);
    return response
  },
  async uploadInternFormFile ({ commit }, params) {
    const response = await uploadInternFormFile(params);
    return response
  },
  async downloadInternFormFile ({ commit }, params) {
    const response = await downloadInternFormFile(params);
    return response
  },
  async getTeacherReminder ({ commit }) {
    const response = await getTeacherReminder();
    commit('setTeacherReminder', response);
    return response
  },
}

export const mutations = {
  setCurrentTeacher (state, payload) {
    state.currentTeacher = Object.assign({}, payload)
  },
  resetCurrentTeacher (state, payload) {
    state.currentTeacher = Object.assign({})
  },
  setInternForm (state, payload) {
    state.currentInternForm = Object.assign({}, payload)
  },
  setStudentsList (state, payload) {
    state.currentStudentsList = payload
  },
  setEnterprisesList (state, payload) {
    state.currentEnterprisesList = payload
  },
  setStudentInternRecordList (state, payload) {
    state.currentStudentInternRecordList = payload
  },
  setInternRecordList (state, payload) {
    state.currentInternRecordList = payload
  },
  setInternSearchOptions (state, payload) {
    state.currentInternSearchOptions = Object.assign({}, payload);
  },
  setTeacherReminder (state, payload) {
    state.currentTeacherReminder = payload;
  },
  setFileNameList (state, payload) {
    state.currentFileNameList = payload;
  },
}
